import React, { useState, useEffect } from 'react';
import { Input, Button, message, Breadcrumb, Select } from 'antd';
import { Link } from 'react-router-dom';
import { Api_VariavelGlobal } from '../global';

const { Option } = Select;

const ConfigMercadoPago = () => {
  const [environment, setEnvironment] = useState("sandbox");
  const [publicKey, setPublicKey] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Buscar credenciais ao carregar a página ou mudar ambiente
  useEffect(() => {
    const fetchCreds = async () => {
      try {
        const url = `${Api_VariavelGlobal}/api-mercadopago/mp/credentials?env=${environment}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('Erro ao buscar credenciais');

        const data = await res.json();

        setPublicKey(data.PUBLIC_KEY || "");
        setAccessToken(data.ACCESS_TOKEN || "");
        setClientId(data.CLIENT_ID || "");
        setClientSecret(data.CLIENT_SECRET || "");

      } catch (error) {
        console.error(error);
        message.error("Erro ao carregar credenciais");
      }
    };

    fetchCreds();
  }, [environment]);

  // Salvar credenciais
  const handleSave = async () => {
    if (!publicKey || !accessToken || !clientId || !clientSecret) {
      message.error("Preencha todos os campos");
      return;
    }

    setIsLoading(true);

    try {
      const res = await fetch(`${Api_VariavelGlobal}/api-mercadopago/mp/credentials`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          environment,
          PUBLIC_KEY: publicKey,
          ACCESS_TOKEN: accessToken,
          CLIENT_ID: clientId,
          CLIENT_SECRET: clientSecret
        }),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || "Erro ao salvar credenciais");
      }

      message.success("Credenciais atualizadas com sucesso!");
    } catch (error) {
      console.error(error);
      message.error(`Erro ao salvar credenciais: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="content-wrapper">
      <h3>Mercado Pago – Configurações</h3>

      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>
          <Link to="/">Início</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Mercado Pago</Breadcrumb.Item>
      </Breadcrumb>

      <div style={{ marginTop: 20, maxWidth: 400 }}>
        {/* Ambiente */}
        <label><b>Ambiente:</b></label>
        <Select
          value={environment}
          onChange={setEnvironment}
          style={{ width: "100%", marginTop: 8 }}
        >
          <Option value="sandbox">Sandbox (Testes)</Option>
          <Option value="production">Produção</Option>
        </Select>

        {/* Public Key */}
        <label style={{ marginTop: 15, display: "block" }}>
          <b>Public Key:</b>
        </label>
        <Input
          placeholder="Ex: TEST-xxxxxx"
          value={publicKey}
          onChange={(e) => setPublicKey(e.target.value)}
        />

        {/* Access Token */}
        <label style={{ marginTop: 15, display: "block" }}>
          <b>Access Token:</b>
        </label>
        <Input.Password
          placeholder="Ex: TEST-xxxxxxxx"
          value={accessToken}
          onChange={(e) => setAccessToken(e.target.value)}
        />

        {/* Client ID */}
        <label style={{ marginTop: 15, display: "block" }}>
          <b>Client ID:</b>
        </label>
        <Input
          placeholder="Ex: PROD_CLIENT_ID"
          value={clientId}
          onChange={(e) => setClientId(e.target.value)}
        />

        {/* Client Secret */}
        <label style={{ marginTop: 15, display: "block" }}>
          <b>Client Secret:</b>
        </label>
        <Input.Password
          placeholder="Ex: PROD_CLIENT_SECRET"
          value={clientSecret}
          onChange={(e) => setClientSecret(e.target.value)}
        />

        <Button
          type="primary"
          onClick={handleSave}
          loading={isLoading}
          style={{ marginTop: 20, width: "100%" }}
        >
          Salvar
        </Button>
      </div>
    </div>
  );
};

export default ConfigMercadoPago;
